module.exports = "/dist/c8bdd772c0d1347720ff7e3fb72719f3.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900.woff2
// module id = 141
// module chunks = 0